import {Component, OnInit} from '@angular/core';
import {DataService} from '../../services/data.service';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

    public dataReady = false;

    public domainIsWrong = false;
    public videoNotExist = false;

    constructor(public data: DataService,
                public route: ActivatedRoute) {
        route.params.subscribe(value => {

            this.data.getVideoInfo(value.secret).subscribe({
                next: value1 => {

                    // All good
                    this.domainIsWrong = false;

                    if (value1.domainProtection && value1.domainProtection.length > 0) {

                        this.domainIsWrong = true;
                        for (const domain of value1.domainProtection) {
                            let allowedDomain = '';
                            if (domain.indexOf('http') === 0) {
                                allowedDomain = this.getHostName(domain);
                            } else {
                                allowedDomain = domain;
                            }

                            if (allowedDomain === this.getHostName(document.referrer)) {
                                this.domainIsWrong = false;

                            }
                        }

                    }


                    route.queryParams.subscribe(value2 => {
                        if (value2.hasOwnProperty('autoplay') && value2.autoplay === '1') {
                            this.data.autoplay = true;
                        }
                        if (value2.hasOwnProperty('countdown') && value2.countdown === '1') {
                            this.data.countdown = true;
                        }
                        if (value2.hasOwnProperty('controls') && value2.controls === '1') {
                            this.data.controls = true;
                        }
                        if (value2.hasOwnProperty('speed') && value2.speed === '1') {
                            this.data.speed = true;
                        }
                        if (value2.hasOwnProperty('allowpause') && value2.allowpause === '1') {
                            this.data.allowPause = true;
                        }
                        if (value2.hasOwnProperty('soundfs') && value2.soundfs === '1') {
                            this.data.soundfs = true;
                        }
                        if (value2.hasOwnProperty('loop') && value2.loop === '1') {
                            this.data.loop = true;
                        }
                        if (value2.hasOwnProperty('startTime')) {
                            this.data.startTime = value2.startTime;
                        }

                        this.dataReady = true;

                    });

                },
                error: err => {
                    console.log(err);
                    this.videoNotExist = true;
                }
            });


        });
    }

    ngOnInit(): void {
    }

    getHostName(url): any {
        const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
            return match[2];
        } else {
            return null;
        }
    }

    getPosterUrl(): string {
        return environment.serverUrl + this.data.videoData.poster;
    }

}
